import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);
  
  useEffect(() => {
    const handlePaymentResponse = async () => {
      const status = searchParams.get('status');
      const transactionId = searchParams.get('transaction_id');
      const orderId = searchParams.get('order_id');
      
      // console.log('Payment callback received:', { status, transactionId, orderId });
      
      if (status === 'success' || status === 'SUCCESS') {
        // Payment successful
        Swal.fire({
          icon: 'success',
          title: 'Payment Successful!',
          text: 'Your order has been confirmed successfully.',
          timer: 2000,
          showConfirmButton: false
        });
        
        // Clear cart data
        sessionStorage.removeItem('appliedCoupon');
        sessionStorage.removeItem('currentOrder');
        
        // Trigger cart update event
        window.dispatchEvent(new Event('cartUpdated'));
        
        // Redirect to order confirmation page
        setTimeout(() => {
          window.location.href = '/Placeorder';
        }, 2000);
      } else if (status === 'failure' || status === 'FAILURE') {
        // Payment failed
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'Your payment could not be processed. Please try again.',
          confirmButtonText: 'Try Again',
          confirmButtonColor: '#0d6efd'
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect back to checkout
            window.location.href = '/checkout';
          }
        });
      } else {
        // Payment pending or unknown status
        Swal.fire({
          icon: 'info',
          title: 'Payment Pending',
          text: 'Your payment is being processed. You will receive a confirmation shortly.',
          confirmButtonText: 'View Order',
          confirmButtonColor: '#0d6efd'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/Placeorder';
          }
        });
      }
      
      setProcessing(false);
    };
    
    handlePaymentResponse();
  }, [searchParams]);
  
  return (
    <div className="payment-callback-container">
      <div className="container text-center py-5">
        {processing ? (
          <div>
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <h3 className="mt-3">Processing Payment...</h3>
            <p className="text-muted">Please wait while we confirm your payment</p>
          </div>
        ) : null}
      </div>
      
      <style>{`
        .payment-callback-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
      `}</style>
    </div>
  );
};

export default PaymentCallback;